export default "__VITE_ASSET__d0vvHSUg__"